<template>
  <i-love-you></i-love-you>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import iLoveYou from './components/iLoveYou.vue';

@Options({
  components: {
    iLoveYou,
  },
})
export default class App extends Vue { }
</script>

<style lang="scss">

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f7c6d9; /* Fundo rosa claro */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0;
  min-height: 100vh; /* Garante que o fundo cubra toda a altura da tela */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7c6d9; /* Define o fundo rosa claro no app */
  overflow-x: hidden;
}

</style>